import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AllDestinationComponent } from './all-destination.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';


@NgModule({
  providers: [LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/destinations', component: AllDestinationComponent, canActivate:[LanguageInterceptor] }, //ENG == FRA
      { path: ':language/destinos', component: AllDestinationComponent, canActivate:[LanguageInterceptor] },   
      { path: ':language/reiseziele', component: AllDestinationComponent, canActivate:[LanguageInterceptor] },
      { path: ':language/destinazioni', component: AllDestinationComponent, canActivate:[LanguageInterceptor] },
    ])
  ]
})
export class AllDestinationRoutingModule { }
